function test() {
  let Sample = document.getElementById("rollsecond");
  Sample.classList.add("test");
}
function myFunction() {
  let Sample = document.getElementById("roll");
  Sample.classList.add("mystyle");
}

 const navbarCloses = document.querySelectorAll('.js-drawer-close');
let html = document.querySelector('html');
let body = document.querySelector('body');

navbarCloses.forEach(item => {
  item.addEventListener('click', function() {
  console.log('click')
    body.classList.remove('js-drawer-open');
    body.classList.remove('js-drawer-open-left');
    html.classList.remove('js-drawer-open');
    html.classList.remove('js-drawer-open-left');
  });
});
